import React, { useContext, useState } from "react";
import BoxComponent from "../../../Box/BoxComponent";
import ImageLogoComponent from "../../../Image/ImageLogoComponent";
import TypographyComponent from "../../../Typography/ThypographyComponent";
import { sidebarMenu, SidebarMenuProps } from "./sidebar.config";
import SidebarButtonComponent from "./SidebarButtonComponent";
import { useNavigate, useParams } from "react-router";
import { AuthContext } from "../../../../provider/auth/AuthContext";
import { EmpresaContext } from "../../../../provider/empresa/EmpresaContext";

interface InfoEmpresaProps {
    nome: string;
    descricao: string;
    image: string;
    aberto: boolean;
}

const SidebarComponent = () => {
    const navigate = useNavigate();
    
    const { empresa: slug } = useParams<{ empresa: string }>();
    const {empresa } = useContext(EmpresaContext);

    const { usuario } = useContext(AuthContext);
    const roles = usuario?.roles || [];

    // Lógica de filtragem
    const filteredMenu = sidebarMenu.filter(item => {
        // Se for adminOnly, checa se tem a Role de gestão
        if (item.adminOnly) {
            return roles.includes("ROLE_DONO") || roles.includes("ROLE_GERENTE");
        }

        // Se exigir permissão específica, checa se ela está na lista
        if (item.requiredPermission) {
            return roles.includes(item.requiredPermission) || roles.includes("ROLE_DONO");
        }

        //Se não tiver trava, permite (ou define uma regra padrão)
        return true;
    });

    // const [infoEmpresa, setInfoEmpresa] = useState<InfoEmpresaProps>({
    //     nome: "GenioAI",
    //     descricao: "Faça seu pedido",
    //     image: LogoIcon,
    //     aberto: false
    // });

    const [statusIFood, setStatusIFood] = useState<boolean>(false);

    const handleRedirectPage = (path: string) => {
        navigate(`/${slug}/dashboard/${path}`);
    }

    if (empresa == null) return;

    return <>
        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                flexDirection: "column",
                opacity: 1,
                transform: 'rotate(0deg)',
                borderColor: 'divider',
                px: '24px',
                py: '32px',
                borderBottom: "1px solid var(--color-orange-87, #E8DFD5)",
                background: "linear-gradient(135deg, #FFFFFF 0%, #F8F5F0 100%)"

            }}
        >
            <BoxComponent
                component="div"
                sx={{
                    display: "flex",
                    gap: 2
                }}
            >
                <ImageLogoComponent
                    alt="logo-empresa"
                    src={empresa.logo}
                    sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "8px",
                        boxShadow: "0px 2px 8px 0px #3D281714"

                    }}
                />
                <BoxComponent
                    component="div"
                    sx={{
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <TypographyComponent
                        variant="h2"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            fontFamily: '"Font 2", sans-serif',
                            fontWeight: 700,
                            fontSize: '18px',
                            lineHeight: '28px',
                            letterSpacing: '0em',
                            textTransform: 'none'
                        }}
                    >
                        {empresa.titulo}
                    </TypographyComponent>
                    <TypographyComponent
                        variant="body2"
                        sx={{
                            // Fonte e Peso
                            fontFamily: '"Font 1", sans-serif',
                            fontWeight: 400,
                            fontSize: '11.3px',
                            lineHeight: '16px',
                            letterSpacing: '0em',

                            color: 'var(--color-orange-43, #7A6B63)',

                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            // px: '8px',
                            py: '2px',
                            borderRadius: '4px',
                            textTransform: 'none',
                            verticalAlign: 'middle',
                        }}
                    >
                        {empresa.descricao}
                    </TypographyComponent>
                </BoxComponent>
            </BoxComponent>
        </BoxComponent>

        {/* STATUS LOJA */}
        <BoxComponent
            component="div"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: "space-between",
                opacity: 1,
                transform: 'rotate(0deg)',
                py: '16px',
                px: '24px',
                backgroundColor: 'var(--color-grey-96, #F8F5F0)',
                borderBottom: '1px solid var(--color-orange-87, #E8DFD5)',
                boxSizing: 'border-box'
            }}
        >
            <TypographyComponent
                variant="body2"
                sx={{
                    fontFamily: '"Font 1", sans-serif',
                    fontWeight: 400,
                    fontSize: '13.1px',
                    lineHeight: '20px',
                    letterSpacing: '0em',
                    color: '#3D2817',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    verticalAlign: 'middle',
                    borderRadius: '6px',
                    textTransform: 'none',
                }}
            >
                Status da loja
            </TypographyComponent>
            <BoxComponent
                component="div"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    opacity: 1
                }}
            >
                <BoxComponent
                    component="div"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: "center",
                        width: "8px",
                        height: "8px",
                        backgroundColor: empresa?.aberto ? "#00C950" : "#E8000C",
                        borderRadius: "50%"
                    }}
                ></BoxComponent>

                <TypographyComponent
                    variant="body2"
                    sx={{
                        fontFamily: '"Font 1", sans-serif',
                        fontWeight: 400,
                        fontSize: '13.1px',
                        lineHeight: '20px',
                        letterSpacing: '0em',
                        color: empresa?.aberto ? "#00C950" : "#E8000C",
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        verticalAlign: 'middle',
                        borderRadius: '6px',
                        textTransform: 'none',
                    }}
                >
                    {empresa?.aberto ? "Aberta" : "Fechada"}
                </TypographyComponent>
            </BoxComponent>
        </BoxComponent>

        {/* STATUS IFOOD */}
        <BoxComponent
            component="div"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                // width: 255,
                // height: 83,
                opacity: 1,
                transform: 'rotate(0deg)',
                py: '16px',
                px: '24px',
                backgroundColor: 'var(--color-grey-96, #F8F5F0)',
                borderBottom: '1px solid var(--color-orange-87, #E8DFD5)',
                boxSizing: 'border-box'
            }}
        >
            <BoxComponent
                component="div"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    transform: 'rotate(0deg)',
                    gap: 2,
                    boxSizing: 'border-box',
                    backgroundColor: 'var(--color-grey-97, #FEF2F2)',
                    borderRadius: '8px',
                    border: '1px solid var(--color-red-89, #FFC9C9)',
                    boxShadow: '0px 2px 8px 0px #3D281714',

                    px: 2, // 32px
                    py: 0.75 // 12px
                }}
            >
                <BoxComponent
                    component="div"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: "center",
                        width: "8px",
                        height: "8px",
                        backgroundColor: statusIFood ? "#00C950" : "#E8000C",
                        borderRadius: "50%"
                    }}
                ></BoxComponent>
                <BoxComponent
                    component="div"
                    sx={{
                        display: 'flex',
                        flexDirection: "column",
                        justifyContent: "center"
                    }}
                >
                    <TypographyComponent
                        variant="body2"
                        sx={{
                            color: "#C10007",
                            fontFamily: '"Font 1", sans-serif',
                            fontWeight: 700, // Bold
                            fontSize: '12px',
                            lineHeight: '16px',
                            letterSpacing: '0em',
                            display: 'inline-flex',
                            alignItems: 'center',
                            verticalAlign: 'middle',
                            textTransform: 'none'
                        }}
                    >
                        iFood
                    </TypographyComponent>

                    <TypographyComponent
                        variant="body2"
                        sx={{
                            color: "#E7000B",
                            fontFamily: '"Font 1", sans-serif',
                            fontWeight: 400, // Regular
                            fontSize: '11.1px',
                            lineHeight: '16px',
                            letterSpacing: '0em',
                            display: 'inline-flex',
                            alignItems: 'center',
                            verticalAlign: 'middle',
                            textTransform: 'none',
                        }}
                    >
                        {empresa.integracaoIfood ? "Integrado" : "Não integrado"}
                    </TypographyComponent>
                </BoxComponent>
            </BoxComponent>
        </BoxComponent>

        {/* BOTÕES */}
        <BoxComponent
            component="nav"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                //width: 255,
                //height: 955,
                opacity: 1,
                transform: 'rotate(0deg)',
                py: '24px',
                px: '16px',
                boxSizing: 'border-box',
                overflowY: 'auto',
                backgroundColor: '#FFFFFF'
            }}
        >
            {filteredMenu && filteredMenu.map((element: SidebarMenuProps, index: number) => {
                return <SidebarButtonComponent
                    label={element.label}
                    path={element.path}
                    icon={element.icon}
                    key={`button-{element.label}-${index}`}
                    onClickOption={(path: string) => handleRedirectPage(path)}
                />
            })}

        </BoxComponent>
    </>

}

export default SidebarComponent;